// Authorization: `token ${token}`,
const httpcallNode = (url, method, body, token, responseType = 'json') => {
    return fetch(`${process.env.REACT_APP_BASE_URL_NODE}/${url}`, {
        method: method,
        body: body,
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            ...token,
        },
    }).then((response) => {

        if (responseType === 'blob') {
            return response.blob();
        }

        return response.json();
    });
};

const httpcallFormDataNode = (url, method, body, token) => {
    return fetch(`${process.env.REACT_APP_BASE_URL_NODE}/${url}`, {
        method: method,
        body: body,
        headers: {
            ...token,
        },
    }).then((response) => response.json());
};

const httpcallPython = (url, method, body, token) => {
    return fetch(`${process.env.REACT_APP_BASE_URL_PYTHON}/${url}`, {
        method: method,
        body: body,
        headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_BASE_URL_PYTHON}`,
            "Content-type": "application/json; charset=UTF-8",
            ...token,
        },
    }).then((response) => response.json());
};

const login = (method, body) => {
    return httpcallNode("adminusers/login", method, body);
};

//-----------------------------------------------Warehouses--------------------------

const getwarehouses = (method, body, token) => {
    return httpcallNode("admin/warehouse/all", method, body, token);
};
const getWalletAdjustment = (method, body, token) => {
    return httpcallNode("adminusers/adjustWallet", method, body, token);
};

const AddWarehouse = (method, body, token) => {
    return httpcallNode("admin/warehouse/add", method, body, token);
};
const updateWarehouse = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/update`, method, body, token);
};
const getWarehousebyId = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/warehouse-details`, method, body, token);
};
const DeleteWarehouse = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/delete`, method, body, token);
};
const getUserDetails = (method, body, token, id) => {
    return httpcallNode(`adminusers/mobilityUser/${id}`, method, body, token);
};


// ---------------------Vendors----------------------------------- 

const getVendors = (method, body, token) => {
    return httpcallNode("adminusers/listvendors", method, body, token);
};
const GetvendorDetails = (method, body, token, id) => {
    return httpcallNode(`adminusers/vendordetail/${id}`, method, body, token)
}
const UpdatevendorDetails = (method, body, token, id) => {
    return httpcallNode(`adminusers/updatevendor/${id}`, method, body, token)
}
const ApproveVendorDocs = (method, body, token, id) => {
    return httpcallNode(`adminusers/updatevendordocs/${id}`, method, body, token)
}
const VendorDelete = (method, body, token, mobileNumber) => {
    return httpcallNode(`adminusers/deletevendor/${mobileNumber}`, method, body, token)
}
const VendorDocDelete = (method, body, token, id) => {
    return httpcallNode(`adminusers/deletevendordoc/${id}`, method, body, token)
}
const filterVendorByServices = (method, body, token) => {
    return httpcallNode(`adminusers/vendors_by_subcategory`, method, body, token)
}
const searchVendors = (method, body, token) => {
    return httpcallNode(`adminusers/searchvendors`, method, body, token)
}


//------------------------------------------Category--------------------------------------

const Get_Omnimart_Categories = (method, body, token) => {
    return httpcallNode(`adminusers/listomni_categories`, method, body, token)
}
const AddCategory = (method, body, token) => {
    return httpcallNode(`adminusers/addcategory`, method, body, token)
}
const updateCategory = (method, body, token, id) => {
    return httpcallNode(`adminusers/updatecategory/${id}`, method, body, token)
}

const deleteCategory = (method, body, token, id) => {
    return httpcallNode(`adminusers/deletecategory/${id}`, method, body, token)
}
const Get_all_Categories = (method, body, token) => {
    return httpcallNode(`adminusers/categorydropdown`, method, body, token)
}
/// -----------------service-category-------------- 

const Get_service_Categories = (method, body, token) => {
    return httpcallNode(`adminusers/getservicecategory`, method, body, token)
}
const Get_service_dropdown = (method, body, token) => {
    return httpcallPython(`admin/servicecategorydropdown`, method, body, token)
}

const add_service_Categories = 'adminusers/add_servicecategory'
const Update_service_Categories = 'adminusers/updateservicecategory'

//----------------------------------------subcategories--------------
const Get_sub_Categories = (method, body, token) => {
    return httpcallNode(`adminusers/getservicesubcategory`, method, body, token)
}

const Add_Subcategory = 'adminusers/add_service_subcategory'
const update_Subcategory = 'adminusers/updateservicesubcategory'

const Delete_subcategory_image = (method, body, token) => {
    return httpcallNode(`adminusers/deletesubcategoryimages`, method, body, token)
}
const Get_SubCategory_Dropdown = (method, body, token) => {
    return httpcallNode(`adminusers/subcategorydropdown`, method, body, token)
}

//-------------------USERS---------------------
const GET_USERS = (method, body, token) => {
    return httpcallPython(`admin/getusers`, method, body, token)
}
// -------------------Services----------------

const Get_ALL_Serives = (method, body, token) => {
    return httpcallNode(`adminusers/getserviceslist`, method, body, token)
}
const Add_Services = `adminusers/addservice`

const Update_Services = `adminusers/updateservices`
const Delete_service_image = (method, body, token) => {
    return httpcallNode(`adminusers/deleteserviceimages`, method, body, token)
}
const Add_Services_city = (method, body, token) => {
    return httpcallPython(`admin/addservicespricebycity`, method, body, token)
}
const Update_Service_City = 'admin/updateservicespricebycity'
//-----------------Products---------------
const Get_Products = (method, body, token) => {
    return httpcallNode(`adminusers/listomni_products`, method, body, token)
}
const add_Products = (method, body, token) => {
    return httpcallNode(`adminusers/addproduct`, method, body, token)
}
const update_Products = (method, body, token, id) => {
    return httpcallNode(`adminusers/updateproduct/${id}`, method, body, token)
}
const productSearch = (method, body, token, id) => {
    return httpcallNode(`adminusers/listomni_products_search`, method, body, token)
}
//------------------warehouse Products-----------------

const getWarehouseProducts = (method, body, token, id, offset) => {
    return httpcallNode(`admin/warehouse/${id}/products/all?Offset=${offset}`, method, body, token)
}
const searchWarehouseProducts = (method, body, token, id, offset) => {
    return httpcallNode(`admin/warehouse/${id}/products/searchbyname?Offset=${offset}`, method, body, token)
}
const addwarehouseProducts = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/products/add`, method, body, token)
}
const GETwarehouseProductsbYProductId = (method, body, token, warehouseid, productId) => {
    return httpcallNode(`admin/warehouse/${warehouseid}/products/${productId}/product-details`, method, body, token)
}
const updateWarehouseProducts = (method, body, token, warehouseid, productId) => {
    return httpcallNode(`admin/warehouse/${warehouseid}/products/${productId}/update`, method, body, token)
}


//---------------Banners------------------

const ServiceBanners = (method, body, token) => {
    return httpcallNode('adminusers/getuserbanner_new', method, body, token)
}

const addServiceBanners = 'adminusers/adduserbanner_new'

const updateBanners = 'adminusers/updateuserbanner'
const updateserviceBannerImage = 'adminusers/updateuserbanner'

const deleteServiceBanners = (method, body, token) => {
    return httpcallNode('adminusers/deletebannerimage', method, body, token)
}
//-----------------omnimart banners--------------

const OmniBanners = (method, body, token) => {
    return httpcallNode('adminusers/listomni_banners', method, body, token)
}
const addOmniBanners = (method, body, token) => {
    return httpcallNode('adminusers/addbanner', method, body, token)
}
const updateomnibanners = (method, body, token) => {
    return httpcallNode('adminusers/updatebanner', method, body, token)
}
const deletebanners = (method, body, token) => {
    return httpcallNode('adminusers/deletebanner', method, body, token)
}
// ----------------------Coupons -----------------------
const getCoupons = (method, body, token) => {
    return httpcallPython('admin/getcoupons', method, body, token)
}
const deleteCoupen = (method, body, token, id) => {
    return httpcallPython(`admin/deletecoupons?couponid=${id}`, method, body, token)
}
const addCoupon = 'admin/savecoupon'
const updateCoupon = 'admin/updatecoupon'

// --------------------Orders---------------------

//service 
const ServiceOrders = (method, body, token, status) => {
    return httpcallPython(`admin/getserviceorders?status=${status}`, method, body, token)
}
const GroceryOrders = (method, body, token, status) => {
    return httpcallPython(`admin/getgroceryorders?status=${status}`, method, body, token)
}
const OrdersInfo = (method, body, token, id) => {
    return httpcallPython(`admin/orderinfo?orderid=${id}`, method, body, token)
}
const updateOrderStatus = (method, body, token, id) => {
    return httpcallPython(`admin/updateorder?orderid=${id}`, method, body, token)
}
//----------------------Cities ---------------------
const getcities = (method, body, token) => {
    return httpcallPython(`admin/getcities`, method, body, token)
}
const addCity = (method, body, token) => {
    return httpcallPython(`admin/addcity`, method, body, token)
}
const updatecity = (method, body, token) => {
    return httpcallPython(`admin/updatecity`, method, body, token)
}

//----------------------states---------------------
const getStates = (method, body, token) => {
    return httpcallPython(`admin/getstates`, method, body, token)
}

const addState = (method, body, token) => {
    return httpcallPython(`admin/addstate`, method, body, token)
}
const updateState = (method, body, token) => {
    return httpcallPython(`admin/updatestate`, method, body, token)
}
//----------------------pincodes---------------------

const getpincode = (method, body, token) => {
    return httpcallPython(`admin/getpincodes`, method, body, token)
}
const addpincode = (method, body, token) => {
    return httpcallPython(`admin/addpincode`, method, body, token)
}
const updatepincode = (method, body, token) => {
    return httpcallPython(`admin/updatepincode`, method, body, token)
}
const packorder = (method, body, token) => {
    return httpcallPython(`admin/packorder`, method, body, token)
}

//---------------------Shop------------
const getShop = (method, body, token) => {
    return httpcallPython(`admin/getshops`, method, body, token)
}
const addShop = (method, body, token) => {
    return httpcallPython(`admin/addshop`, method, body, token)
}
const editShop = "admin/editshop"

//--------------------suggestions---------------------------

const suggestions = (method, body, token) => {
    return httpcallPython(`admin/getsuggestions`, method, body, token)
}

//-------------------------roles----------
const AddAdminroles = (method, body, token) => {
    return httpcallNode(`adminusers/addadminrole`, method, body, token)
}
const getAdminroles = (method, body, token) => {
    return httpcallNode(`adminusers/adminrolelist`, method, body, token)
}
const UpdateAdminroles = (method, body, token, id) => {
    return httpcallNode(`adminusers/updateadminrole/${id}`, method, body, token)
}
const DeleteAdminroles = (method, body, token, id) => {
    return httpcallNode(`adminusers/deleteadminrole/${id}`, method, body, token)
}

//-----------------admin Users---------------
const adminUsers = (method, body, token) => {
    return httpcallNode(`adminusers/list`, method, body, token)
}
const addAdminUser = (method, body, token) => {
    return httpcallNode(`adminusers/addadmin`, method, body, token)
}

const updateAdmindata = (method, body, token, id) => {
    return httpcallNode(`adminusers/updateadminuser/${id}`, method, body, token)
}
//-----------------------Suppliers--------
const getAllSuppliers = (method, body, token) => {
    return httpcallNode(`admin/suppliers/all`, method, body, token)
}
const addSupplier = (method, body, token) => {
    return httpcallNode(`admin/suppliers/add`, method, body, token)
}
const SupplierById = (method, body, token, id) => {
    return httpcallNode(`admin/suppliers/byId/${id}`, method, body, token)
}
const UpdateSupplier = (method, body, token, id) => {
    return httpcallNode(`admin/suppliers/${id}`, method, body, token)
}
const SupplierSearch = (method, body, token, name) => {
    return httpcallNode(`admin/suppliers/byname/${name}`, method, body, token)
}
//-------------------Purchase Orders---------------

const getPoentryById = (method, body, token, id, offset) => {
    return httpcallNode(`admin/warehouse/${id}/POentries?Offset=${offset}`, method, body, token)
}
const getpoentryDetails = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/POentry-Details`, method, body, token)
}
const ProductSearchpOST = (method, body, token, search) => {
    return httpcallNode(`admin/warehouse/products/search?searchKey=${search}`, method, body, token)
}
const PoitemsByProductId = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/POitems/byproductId/${id}`, method, body, token)
}
const addPoentry = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/POentry/add`, method, body, token)
}
const poentryById = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/POentry-Details`, method, body, token)
}
const searchPoentry = (method, body, token, id) => {
    return httpcallNode(`admin/warehouse/${id}/search-POentry
    `, method, body, token)
}
const getLedger = (method, body, token, prodId, warehouseId) => {
    return httpcallNode(`admin/warehouse/${warehouseId}/ledger/${prodId}/byproduct`, method, body, token)
}
const editLedger = (method, body, token, warehouseId) => {
    return httpcallNode(`admin/warehouse/${warehouseId}/stock-adjustment
    `, method, body, token)
}
//----------------------Societies----------------------
const getSocieties = (method, body, token) => {
    return httpcallPython(`admin/societies`, method, body, token)
}

const addSociety = (method, body, token) => {
    return httpcallPython(`admin/addsociety`, method, body, token)
}

const updateSociety = (method, body, token, ID) => {
    return httpcallPython(`admin/societyupdate/${ID}`, method, body, token)
}
//------------------------Customer Support -----------------------
const CustomerSupport = (method, body, token) => {
    return httpcallNode(`adminusers/list_customersupport`, method, body, token)
}
const Add_CustomerSupport = (method, body, token) => {
    return httpcallNode(`adminusers/add_customersupport`, method, body, token)
}

const Admin_Settings = (method, body, token, id) => {
    return httpcallNode(`adminusers/timeslots?Type=${id}`, method, body, token)
}


const Update_Settings = (method, body, token, id) => {
    return httpcallNode(`adminusers/update_timeslots/${id}`, method, body, token)
}
const add_slot = (method, body, token) => {
    return httpcallNode(`adminusers/add_timeslots`, method, body, token)
}

const ServiceByCity = (method, body, token) => {
    return httpcallPython(`admin/getservicespricebycity`, method, body, token)
}
const ServiceByCitySearch = (method, body, token) => {
    return httpcallPython(`admin/searchservicespricebycity`, method, body, token)
}

const SearchServices = (method, body, token) => {
    return httpcallPython(`admin/searchservices`, method, body, token)
}
const DeleteCityWiseServices = (method, body, token) => {
    return httpcallPython(`admin/deleteservicespricebycity`, method, body, token)
}

const Sales_Dashboard = (method, body, token, type) => {
    return httpcallNode(`adminusers/${type}`, method, body, token)
}
const stockValue_Dashboard = (method, body, token) => {
    return httpcallNode(`adminusers/getstockvalue`, method, body, token)
}

const allReportsDownload = (method, body, token) => {
    return httpcallNode(`adminusers/all_reports`, method, body, token)
}
const allVendors = (method, body, token) => {
    return httpcallNode(`adminusers/allvendors`, method, body, token)
}

const get_DeliveryTypes = (method, body, token) => {
    return httpcallPython(`admin/get_pickupdelivery_types`, method, body, token)
}
const GetGst = (method, body, token, city) => {
    return httpcallPython(`salesapp/servicesales?city=${city}`, method, body, token)
}
const GetGstProduct = (method, body, token, city) => {
    return httpcallPython(`salesapp/productsales?city=${city}`, method, body, token)
}
const updateVendorServiceOrder = (method, body, token, Mobile, orderId) => {
    return httpcallPython(`vendor/admin_bookronot?mobile=${Mobile}&status=Yes&orderid=${orderId}`, method, body, token)
}
const DeleteService = (method, body, token) => {
    return httpcallNode(`adminusers/deleteservice`, method, body, token)
}
const add_DeliveryTypes = "admin/add_pickupdelivery_types"
const update_DeliveryTypes = "admin/update_pickupdelivery_types"
const Delete_Pickup_Type = "admin/delete_pickupdelivery_types"



//---------------------------------Mobility Services------------

const Mobility_GetUsers = (method, body, token, page = 1, mobile) => {
    // Create query parameters dynamically
    const queryParams = new URLSearchParams({
        page: page,
        size: 15,
        ...(mobile && { mobile }) // Include 'mobile' only if it's provided
    }).toString();

    return httpcallNode(`adminusers/mobilityUsers?${queryParams}`, method, body, token);
}
const Mobility_Bookings = (method, body, token, status, page = 1, mobile) => {
    // Create query parameters dynamically
    const queryParams = new URLSearchParams({
        page: page,
        size: 15,
        ...(mobile && { ...mobile }) // Include 'mobile' only if it's provided
    }).toString();

    return httpcallNode(`adminusers/bookings/${status}?${queryParams}`, method, body, token);
}
const Download_Bookings = (method, body, token, status, mobile) => {
    // Create query parameters dynamically
    const queryParams = new URLSearchParams({

        ...mobile // Include 'mobile' only if it's provided
    }).toString();

    return httpcallNode(`adminusers/bookings/${status}/download?${queryParams}`, method, body, token, 'blob');
}
const Mobility_Drivers = (method, body, token, status, page = 1, mobile, order, isactive) => {
    // Create query parameters dynamically
    const queryParams = new URLSearchParams({
        page: page,
        size: 15,
        ...(mobile && { mobile }), // Include 'mobile' only if it's provided
        ...(isactive && { isactive }),
        ...(order && { order })
    }).toString();

    return httpcallNode(`adminusers/mobilityDrivers/${status}?${queryParams}`, method, body, token);
}
const BookingDetails = (method, body, token, id, type) => {


    return httpcallNode(`adminusers/booking/${id}?type=${type}`, method, body, token);
}
const DriverDetails = (method, body, token, id) => {


    return httpcallNode(`adminusers/mobilityDriver/${id}`, method, body, token);
}
const ApproveRejectDocument = (method, body, token) => {


    return httpcallNode(`adminusers/changeDocumentStatus`, method, body, token);
}
const ApproveRejectVehicle = (method, body, token) => {


    return httpcallNode(`adminusers/changeVehicleStatus`, method, body, token);
}
const getMObilityBanners = (method, body, token) => {
    return httpcallNode(`adminusers/banners`, method, body, token);
}
const updateBannerMobility = (method, body, token, id) => {
    return httpcallNode(`adminusers/updateBanner/${id}`, method, body, token);
}
const UploadImage = (method, body, token) => {
    return httpcallFormDataNode(`adminusers/uploadImage`, method, body, token);
}
const UploadImages = (method, body, token) => {
    return httpcallFormDataNode(`adminusers/UploadImages`, method, body, token);
}
const UpdateRequest = (method, body, token, id) => {
    return httpcallNode(`adminusers/updateWithdrawRequests/${id}`, method, body, token);
}
const getWithDrawRequest = (method, body, token, requestId, page = 1) => {
    const queryParams = new URLSearchParams({
        page: page,
        size: 15,
        // Include 'mobile' only if it's provided
    }).toString();
    return httpcallNode(`adminusers/withdrawRequests/${requestId}?${queryParams}`, method, body, token);
}
const getTransportServices = (method, body, token, booking_type, page = 1) => {
    const queryParams = new URLSearchParams({
        page: page,
        size: 15,
    }).toString();
    return httpcallNode(`adminusers/transportServices/${booking_type}?${queryParams}`, method, body, token);
}
const AddTransportServices = (method, body, token) => {
    return httpcallNode(`adminusers/transportService/add`, method, body, token);
}
const updateTransportServices = (method, body, token, serviceId) => {
    return httpcallNode(`adminusers/transportService/update/${serviceId}`, method, body, token);
}
const DeleteTransport = (method, body, token, serviceId) => {
    return httpcallNode(`adminusers/transportService/delete/${serviceId}`, method, body, token);
}
const GetMobilityCoupons = (method, body, token) => {
    return httpcallNode(`adminusers/coupons`, method, body, token);
}
const DeleteMobilityCoupons = (method, body, token, id) => {
    return httpcallNode(`adminusers/coupon/delete/${id}`, method, body, token);
}
const updateMobilityCoupon = (method, body, token, id) => {
    return httpcallNode(`adminusers/coupon/update/${id}`, method, body, token);
}
const addMobilityCoupon = (method, body, token) => {
    return httpcallNode(`adminusers/coupon/add`, method, body, token);
}
const MobilityConfig = (method, body, token) => {
    return httpcallNode(`adminusers/config`, method, body, token);
}

const MobilityConfiguPDATE = (method, body, token, id) => {
    return httpcallNode(`adminusers/config/update/${id}`, method, body, token);
}

const MobilityDriverUserUpdate = (method, body, token, id) => {
    return httpcallNode(`adminusers/user/update/${id}`, method, body, token);
}

const Mobility_GetCities = (method, body, token) => {
    return httpcallNode(`adminusers/cities`, method, body, token);
}
const Mobility_AddCity = (method, body, token) => {
    return httpcallNode(`adminusers/city/add`, method, body, token);
}
const Mobility_UpdateCity = (method, body, token, city_id) => {
    return httpcallNode(`adminusers/city/update/${city_id}`, method, body, token);
}

const updateBooking = (method, body, token) => {
    return httpcallNode(`adminusers/updateBooking`, method, body, token);
}
const remindDriver = (method, body, token) => {
    return httpcallNode(`adminusers/remindDriver`, method, body, token);
}
const getGuideCategories = (method, body, token) => {
    return httpcallNode(`adminusers/guideCategories`, method, body, token);
}
const getGuideByCategories = (method, body, token, id) => {
    return httpcallNode(`adminusers/guides?category_id=${id}`, method, body, token);
}
const addGuideByCategories = (method, body, token, id) => {
    return httpcallNode(`adminusers/guide/add`, method, body, token);
}
const updateGuideByCategories = (method, body, token) => {
    return httpcallNode(`adminusers/guide/update`, method, body, token);
}
const deleteGuideByCategories = (method, body, token, id) => {
    return httpcallNode(`adminusers/guide/delete?id=${id}`, method, body, token);
}
const getNotifications = (method, body, token, type) => {
    return httpcallNode(`adminusers/notifications?topic=${type}`, method, body, token);
}
const sendNotifications = (method, body, token) => {
    return httpcallNode(`adminusers/sendNotification`, method, body, token);
}
const sendNotificationSingle = (method, body, token) => {
    return httpcallNode(`adminusers/sendNotificationToID`, method, body, token);
}

export const Services = {
    sendNotificationSingle,
    sendNotifications,
    addGuideByCategories, updateGuideByCategories, deleteGuideByCategories,
    getGuideByCategories,
    getGuideCategories, getNotifications,
    remindDriver,
    updateBooking,
    Download_Bookings,
    UploadImages,
    MobilityDriverUserUpdate,
    Mobility_GetCities,
    Mobility_AddCity,
    Mobility_UpdateCity,
    MobilityConfiguPDATE,
    MobilityConfig,
    updateMobilityCoupon, addMobilityCoupon,
    GetMobilityCoupons, DeleteMobilityCoupons,
    DeleteTransport,
    updateTransportServices,
    AddTransportServices,
    getTransportServices,
    UpdateRequest,
    getWithDrawRequest,
    UploadImage,
    updateBannerMobility,
    ApproveRejectVehicle,
    getMObilityBanners,
    ApproveRejectDocument,
    login, BookingDetails, Mobility_Drivers, DriverDetails,
    add_DeliveryTypes, Mobility_GetUsers, Mobility_Bookings,
    GetGst,
    stockValue_Dashboard, getWalletAdjustment,
    get_DeliveryTypes,
    Sales_Dashboard,
    allReportsDownload,
    updateVendorServiceOrder,
    getwarehouses,
    ServiceByCitySearch,
    getWarehousebyId,
    DeleteCityWiseServices,
    ServiceByCity,
    update_DeliveryTypes,
    Admin_Settings,
    AddWarehouse,
    add_slot,
    updateWarehouse,
    DeleteWarehouse,
    GetGstProduct,
    allVendors,
    SearchServices,
    getVendors,
    GetvendorDetails,
    UpdatevendorDetails,
    ApproveVendorDocs,
    Delete_Pickup_Type,
    VendorDelete,
    VendorDocDelete,
    Get_Omnimart_Categories,
    AddCategory,
    Get_service_Categories,
    updateCategory,
    Get_service_dropdown,
    deleteCategory,
    add_service_Categories,
    Update_Service_City,
    Get_sub_Categories,
    Update_service_Categories,
    Add_Subcategory,
    Get_all_Categories,
    update_Subcategory,
    Get_ALL_Serives,
    Get_Products,
    Delete_subcategory_image,

    Get_SubCategory_Dropdown,
    Add_Services,
    Update_Services,
    Add_Services_city,
    Delete_service_image,
    add_Products,
    update_Products,
    ServiceBanners,
    addServiceBanners,
    deleteServiceBanners,
    updateBanners,
    OmniBanners,
    updateomnibanners, getUserDetails,
    getCoupons,
    addCoupon,
    updateCoupon,
    ServiceOrders,
    GroceryOrders,
    OrdersInfo,
    updateOrderStatus,
    getcities,
    getStates,
    addState,
    addCity,
    getpincode,
    addpincode,
    updateState,
    updatecity,
    updatepincode,
    updateserviceBannerImage,
    addOmniBanners,
    packorder,
    deletebanners,
    getShop,
    addShop,
    editShop,
    productSearch,
    GET_USERS,
    deleteCoupen,
    suggestions,
    AddAdminroles,
    getAdminroles,
    UpdateAdminroles,
    DeleteAdminroles,
    adminUsers,
    addAdminUser,
    updateAdmindata,
    filterVendorByServices,
    searchVendors,
    getWarehouseProducts,
    addwarehouseProducts,
    searchWarehouseProducts,
    GETwarehouseProductsbYProductId,
    updateWarehouseProducts,
    getAllSuppliers,
    addSupplier,
    SupplierById,
    UpdateSupplier,
    getPoentryById,
    getpoentryDetails,
    SupplierSearch,
    ProductSearchpOST,
    PoitemsByProductId,
    addPoentry,
    poentryById,
    searchPoentry,
    getLedger,
    editLedger,
    getSocieties,
    addSociety,
    updateSociety,
    CustomerSupport,
    Add_CustomerSupport,
    Update_Settings,
    DeleteService
};
